import { useTranslation } from "@equiem/web-ng-lib";
import { ProgressCircle } from "@equiem/web-ng-lib";
import React from "react";
import { BuildingInfoPost, EventOccurrence, NewsPost } from ".";
import { usePublicContentViewQuery } from "../../generated/gateway-client";
import { ContentNotAvailable } from "../ContentNotAvailable";

interface Props {
  id: string;
}

export const ShareableContent: React.FC<Props> = ({ id }) => {
  const { t } = useTranslation();

  const { loading, data, error } = usePublicContentViewQuery({
    variables: { shareableLinkId: id },
  });

  if (loading) {
    return (
      <div className="text-center py-3">
        <ProgressCircle size="lg" />
      </div>
    );
  }

  switch (data?.publicContentView.node?.__typename) {
    case "Occurrence":
      return <EventOccurrence post={data.publicContentView.node} />;
    case "NewsPost":
      return <NewsPost post={data.publicContentView.node} />;
    case "BuildingInfoPost":
      return <BuildingInfoPost post={data.publicContentView.node} />;
  }

  return (
    <ContentNotAvailable
      title={error?.message ?? t("main.contentDoesNotExistOrNotAccessible")}
    />
  );
};
